import React, {Fragment, useState, useEffect} from 'react'
import {Accordion, Form, Icon} from 'semantic-ui-react'
import * as StoriesActions from '../../../actions/StoriesActions'
import {useDispatch, useSelector} from 'react-redux';

export const Timespans = (props) => {
    const [active, setActive] = useState(false);

    const dispatch = useDispatch();
    const settings = {
        
        ...useSelector(({stories}) => stories.selected.settings)
    }

    return (
        <Fragment>
            <Accordion.Title active={active} onClick={(e) => {
                    setActive(!active);
                }}><Icon name='dropdown' /> Veröffentlichungszeitraum</Accordion.Title>
            <Accordion.Content active={active}>
                <Form>
                    <label style={{
                        display: 'block',
                        fontWeight: 'bold',
                        marginBottom: '0.3em',
                        fontSize: '.92857143em'
                    }}>Veröffentlichen am</label>
                    <Form.Group>
                        <Form.Field>
                            <input disabled={props.readonly?true:null} type="date" value={settings.publish_on_date} onChange={({target}) => {
                                dispatch(StoriesActions.update_settings('publish_on_date', target.value));
                            }} />
                        </Form.Field>
                        <Form.Field>
                            <input disabled={props.readonly?true:null} type="time" value={settings.publish_on_time} onChange={({target}) => {
                                dispatch(StoriesActions.update_settings('publish_on_time', target.value));
                            }}/>
                        </Form.Field>
                    </Form.Group>
                    <label style={{
                        display: 'block',
                        fontWeight: 'bold',
                        marginBottom: '0.3em',
                        fontSize: '.92857143em'
                    }}>Veröffentlichen bis</label>
                    <Form.Group>
                        <Form.Field>
                            <input disabled={props.readonly?true:null} type="date" value={settings.publish_until_date} onChange={({target}) => {
                                dispatch(StoriesActions.update_settings('publish_until_date', target.value));
                            }}/>
                        </Form.Field>
                        <Form.Field>
                            <input disabled={props.readonly?true:null}  type="time" value={settings.publish_until_time} onChange={({target}) => {
                                dispatch(StoriesActions.update_settings('publish_until_time', target.value));
                            }} />
                        </Form.Field>
                    </Form.Group>
                </Form>
            </Accordion.Content>
        </Fragment>
    )
}